import Vue from 'vue'
// import axios from 'axios'
import axios from '@/wrappers/axios.js'

const LogsService = {

    getLogs(id, params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/logs?${params ? params : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    storeLogs(id, data) {
        return new Promise(async (resolve, reject) => {
            axios
                .post(`/logs`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },
    updateLog(id, data) {
        return new Promise(async (resolve, reject) => {
            axios
                .put(`/logs/${id}`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },
}

Vue.$logsService = LogsService

export default LogsService